<template>
    <the-form-layout :init-method="getMsgService" :sure-method="updateMsgService">
        <template #default="{ data: { formDing, formWX } }">
            <the-form-section title="钉钉">
                <isc-form-item label="公司名称 CorpId">
                    <isc-input
                        v-model="formDing.corpId"
                        placeholder="示例：ding04f0f6ce504f11c424f2f5cc6abecb85"
                    ></isc-input>
                </isc-form-item>
                <isc-form-item label="应用 idAgentId">
                    <isc-input v-model="formDing.agentId" placeholder="示例：349851285"></isc-input>
                </isc-form-item>
                <isc-form-item label="appKey">
                    <isc-input v-model="formDing.appKey" placeholder="示例：ding1wcyhzqggqxls1s7"></isc-input>
                </isc-form-item>
                <isc-form-item label="appSecret">
                    <isc-input
                        v-model="formDing.appSecret"
                        placeholder="示例：rOOAzz8dpdOH3si7pHarQJlRX3ZEp2ikOW LP6ct6NGHaAw7W-tWXP7g63_djaLOt"
                    ></isc-input>
                </isc-form-item>
                <isc-form-item label="appCode">
                    <isc-input v-model="formDing.appCode" placeholder="请输入appCode"></isc-input>
                </isc-form-item>
                <isc-form-item>
                    <isc-button
                        type="plain"
                        icon="isc-icon-setting"
                        :disabled="testDisabled1(formDing)"
                        @click="testDingMsg(formDing)"
                    >
                        测试
                    </isc-button>
                </isc-form-item>
            </the-form-section>
            <the-form-section title="企业微信">
                <isc-form-item label="公司名称">
                    <isc-input v-model="formWX.corpName" placeholder="请输入公司名称"></isc-input>
                </isc-form-item>
                <isc-form-item label="应用名称">
                    <isc-input v-model="formWX.appName" placeholder="请输入应用名称"></isc-input>
                </isc-form-item>
                <isc-form-item label="appCode">
                    <isc-input v-model="formWX.appCode" placeholder="请输入appCode"></isc-input>
                </isc-form-item>
                <isc-form-item label="corpSecret">
                    <isc-input v-model="formWX.corpSecret" placeholder="请输入corpSecret"></isc-input>
                </isc-form-item>
                <isc-form-item>
                    <isc-button
                        type="plain"
                        icon="isc-icon-setting"
                        :disabled="testDisabled2(formWX)"
                        @click="testWxMsg(formWX)"
                    >
                        测试
                    </isc-button>
                </isc-form-item>
            </the-form-section>
        </template>
    </the-form-layout>
</template>

<script>
import TheFormLayout from '../components/the-form-layout';
import TheFormSection from '../components/the-form-section';
import { getMsgService, updateMsgService, testMsgService } from './service';
import { openPrompt, showError, showSuccess } from '@/utils/message.ts';

export default {
    name: 'MsgConfig',

    components: {
        TheFormSection,
        TheFormLayout
    },

    data() {
        return {
            getMsgService,
            updateMsgService
        };
    },

    methods: {
        testDisabled1(formDing) {
            return !(formDing.corpId && formDing.agentId && formDing.appKey && formDing.appSecret && formDing.appCode);
        },

        testDisabled2(formWX) {
            return !(formWX.corpName && formWX.appName && formWX.corpSecret && formWX.appCode);
        },

        async testDingMsg(formDing) {
            let value;
            try {
                value = await openPrompt('手机号码', '测试');
            } catch (err) {
                return;
            }

            try {
                await testMsgService(formDing.appCode, 'dt', value);
                showSuccess('测试成功');
            } catch (error) {
                showError(error);
            }
        },

        async testWxMsg(formWX) {
            let value;
            try {
                value = await openPrompt('手机号码', '测试');
            } catch (err) {
                return;
            }

            try {
                await testMsgService(formWX.appCode, 'wcw', value);
                showSuccess('测试成功');
            } catch (error) {
                showError(error);
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
